import { useState } from 'react'
import { Icon } from './Icon'

// Shared icon-only action button (promoted from a local copy in Schools.tsx).
// `label` is required, not optional — an icon-only button with no aria-label is
// a real screen-reader gap, so the type signature doesn't allow reintroducing it.
// Keyboard focus is visible via the global :focus-visible rule in globals.css.

export function IconButton({
  icon, label, tone = 'neutral', onClick,
}: {
  icon: string
  label: string
  tone?: 'neutral' | 'teal' | 'danger'
  onClick: () => void
}) {
  const [hover, setHover] = useState(false)
  const color = tone === 'teal' ? '#0F7C6C' : tone === 'danger' ? 'var(--danger)' : 'var(--ink)'
  const hoverBg = tone === 'teal' ? 'rgba(15,124,108,0.08)' : tone === 'danger' ? 'var(--danger-10)' : 'rgba(27,42,74,0.06)'
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      title={label}
      aria-label={label}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: hover ? hoverBg : 'transparent', border: 'none', borderRadius: 7, cursor: 'pointer',
        padding: '7px', color, transition: 'background-color 0.15s',
      }}
    >
      <Icon path={icon} size={15} />
    </button>
  )
}
